<script lang="ts">
  import type { Snippet } from "svelte"
  import { getAlertRootContext } from "./AlertRoot.svelte"

  type Props = {
    class?: string | null
    level?: number
    children?: Snippet
  }

  let { class: cssClass = undefined, level = 4, children }: Props = $props()

  const rootCtx = getAlertRootContext()
</script>

<div
  class="heading mb-double-extra-small flex items-center font-x-small-600 {cssClass}"
  role="heading"
  aria-level={level}
>
  {#if children}
    {@render children()}
  {:else}
    {$rootCtx.variant}
  {/if}
</div>
